/*
==================================================
CART MOBILE PROMO

Функция:
блок promo code для верхней зоны cart
и modal-окно ввода промокода

Родитель:
index.tsx

Дочерние элементы:
DiscountCode

Использует:
пока без visual config / animation config / controller

Примечания:
на этом этапе файл обслуживает:
- кнопку Promo code в верхней панели
- modal для ввода promo code
==================================================
*/

import DiscountCode from "@modules/checkout/components/discount-code"
import { triggerHaptic } from "../../../../lib/custom-ui/haptics/haptics"

type CartMobilePromoProps = {
  onOpenPromo?: () => void
  openAsModal?: boolean
  onClosePromo?: () => void
  cart?: any
}

export default function CartMobilePromo({
  onOpenPromo,
  openAsModal = false,
  onClosePromo,
  cart,
}: CartMobilePromoProps) {
  if (openAsModal) {
    if (!cart) return null

    return (
      <div className="absolute inset-0 z-50 flex items-start justify-center bg-black/40 px-4 pt-24 backdrop-blur-sm">
        <div className="pointer-events-auto w-full max-w-[360px] rounded-2xl border border-white/15 bg-gradient-to-br from-[#0f172a]/95 via-[#132238]/95 to-[#1e293b]/95 px-4 pb-4 pt-3 shadow-2xl backdrop-blur-xl">
          <div className="mb-3 flex items-center justify-between">
            <span className="text-base font-semibold text-white/90">
              Promo code
            </span>
            <button
              type="button"
              onClick={() => {
                triggerHaptic(5)
                onClosePromo?.()
              }}
              className="text-xl text-white"
            >
              ×
            </button>
          </div>

          <DiscountCode cart={cart as any} />
        </div>
      </div>
    )
  }

  return (
    <button
      type="button"
      onClick={() => {
        triggerHaptic(10)
        onOpenPromo?.()
      }}
      className="flex h-11 flex-[0.68] items-center justify-center rounded-xl border border-white/25 text-[15px] font-bold text-white shadow-lg backdrop-blur-md transition-all active:scale-95"
      style={{
        background:
          "linear-gradient(90deg, #1b2b46 0%, #284469 48%, #3a5f88 100%)",
      }}
    >
      Promo code
    </button>
  )
}
